exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-wrap[data-v-fd2d7ecc] { overflow-x: auto;\n}\n.gl-tpl-table[data-v-fd2d7ecc] { width: 100%; border-collapse: collapse;\n}\n.gl-tpl-table th[data-v-fd2d7ecc], .gl-tpl-table td[data-v-fd2d7ecc] { border: 1px solid #e8e8e8; padding: 4px 6px; font-size: 13px;\n}\n.gl-tpl-table th[data-v-fd2d7ecc] { background: #fafafa;\n}\n", ""]);

// exports
